const IconSuccess = ():JSX.Element => (
  <svg className="modal__icon" width="86" height="80" aria-hidden="true">
    <use xlinkHref="#icon-success"></use>
  </svg>
);
export default IconSuccess;
